/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */

import {
  AppBar,
  Button,
  Card,
  FormControl,
  Grid,
  InputAdornment,
  InputLabel,
  Select,
  Tab,
  Tabs,
  TextField,
} from "@mui/material";
import { GridSearchIcon } from "@mui/x-data-grid";
import breakpoints from "assets/theme/base/breakpoints";
import { BTable } from "components/BTable/BTable";
import { getColorMappings } from "components/ColorComponent/ColorComponent";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import Height from "components/height/height";
import { useMaterialUIController } from "context";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import PageTitle from "examples/PageTitle/PageTitle";
import MuiPhoneNumber from "material-ui-phone-number";
import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate, useParams } from "react-router-dom";
import { appConstants } from "utils/appConstants";
import { generateDataList, getScreenRight } from "utils/generic";
import { getClientPlanFeatures, getClientUsers, getInvoicesAndPayments, getSelectedClients, getSubsciptionTransactions } from "utils/superAdminApi";
let fetchedClientById = {};
function ClientInfo() {
  const { id } = useParams()
  const defaultHrMarginLeft = 20;
  const [table, setTable] = useState("client_info");
  const [hrWidth, setHrWidth] = useState(151);
  const [hrMarginLeft, setHrMarginLeft] = useState(defaultHrMarginLeft);
  const [showClientTable, setshowClientTable] = useState(false);
  const [showPlanFeatureTable, setShowPlanFeatureTable] = useState(false);
  const [showUsersTable, setshowUsersTable] = useState(false);
  const [showTransaction, setshowTransaction] = useState(false);
  const [showinvoicePayments, setshowinvoicePayments] = useState(false);
  const [controller] = useMaterialUIController();
  const { sidenavColor } = controller;
  const { barColor } = getColorMappings(sidenavColor);
  const [customerReload, setCustomerReload] = useState();
  const [checkDisabled, setcheckDisabled] = useState(true);
  const [rows, setRows] = useState([]);
  const [state, setState] = useState("");
  const [country, setCountry] = useState("");
  const [userRows, setuserRows] = useState([]);
  const [subscriptionRows, setsubscriptionRows] = useState([]);
  const [invoiceRows, setinvoiceRows] = useState([]);
  const [disableColor, setDisableColor] = useState(false);
  const [tabsOrientation, setTabsOrientation] = useState("horizontal");
  const [tabValue, setTabValue] = useState(0);
  const [screenName, setScreenName] = useState("Client Information");
  const [totalRows, setTotalRows] = useState(0);
  const [subscriptionTotalRows, setSubscriptionTotalRows] = useState(0);
  const [invoiceTotalRows, setInvoiceTotalRows] = useState(0);
  const [userTotalRows, setUserTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(10);
  let countryData = useSelector((state) => state.countryState.countryStateMenu.country)
  let stateData = useSelector((state) => state.countryState.countryStateMenu.state)
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const [headerValues, setHeaderValues] = React.useState({
    page: appConstants.page,
    limit: appConstants.limit,
    sortingType: "",
    sortingField: "",
    filterValues: "",
    businessUserID: id,
    searchParameterList: ["featureType", "featureName", "featureCount", "notes", "status", "newPlanName", "oldPlanName", "transactionType", "transactionDateTime", "transactionDateString", "userStatus", "role", "userType",
      "emailAddress", "lastName", "firstName", "paymentAmount", "invoiceStatus", "invoiceAmount", "transactionType", "invoiceNumber", "invoiceDate", "invoiceDateString", "paymentDates", "paymentDateString"]
  });

  const [values, setValues] = React.useState({
    companyName: "",
    lastName: "",
    emailAddress: "",
    phoneNumber: "+61",
    _id: "",
    planName: "",
    planActivationDate: "",
    planExpiryDate: "",
    companyStreetAddress: "",
    companyZipCode: "",
    companyCountry: "",
    companyState: "",
    companyCity: "",
    endDate: new Date(),
    businessUserID: "",
    transactionType: "",
    searchParameterList: [],
    searchParameter: "",
    duration: "",
    userStatus: "",
    companyWebsite: "",
    selectedDuration: "",
    customSortOrder: "",
    customSort: "responseDateTime",
    customOrder: "-1",
  });




  useEffect(() => {

    console.log("asdasda", id)
    values.businessUserID = id;
    (async () => {
      getRight()
      setCountry(await generateDataList(countryData, "_id", "countryName"));
      setState(await generateDataList(stateData, "_id", "stateName"))
    })()
    if (
      sessionStorage.getItem("SUBSCRIPTION_PLANS_STORAGE") !== undefined &&
      sessionStorage.getItem("SUBSCRIPTION_PLANS_STORAGE") !== null
    ) {
      setTable(sessionStorage.getItem("SUBSCRIPTION_PLANS_STORAGE"));
      sessionStorage.removeItem("SUBSCRIPTION_PLANS_STORAGE");
    }

    if (id !== undefined) {
      fetchSelectedClients()
    }
  }, []);

  useEffect(() => {
    if (tabValue === 1) {
      fetchClientPlanFeatures();
    } else if (tabValue === 2) {
      fetchSubsciptionTransactions();
    } else if (tabValue === 3) {
      fetchInvoicesAndPayments();
    } else if (tabValue === 4) {
      fetchClientUsers()
    }
  }, [tabValue, customerReload, headerValues.page, headerValues.limit, headerValues.sortingType])

  const clearValues = () => {
    setHeaderValues({
      ...headerValues,
      page: appConstants.page,
      limit: appConstants.limit,
      sortingType: "",
      sortingField: "",
      filterValues: "",
      businessUserID: id
    });

  }
  async function getRight() {
    let right = await getScreenRight("Business Users")
    if (right === "Full Access") setDisableColor(false)
    else setDisableColor(true)
  }

  const fetchSelectedClients = async () => {
    getSelectedClients(values, (data) => {
      if (fetchedClientById) {
        setValues(data.Result_Output[0]);
      }
    }, dispatch)
  }
  const fetchClientPlanFeatures = async () => {
    getClientPlanFeatures(headerValues, (data) => {
      setTotalRows(data.Result_Output.totalDocs);
      setRows(data.Result_Output.docs);
    }, dispatch)
  };


  const setPhoneValues = (phone, country) => {
    values.onlyPhoneNumber = phone.slice(country.dialCode.length);
    values.phoneNumber = phone.slice(country.dialCode.length);
    values.countryCode = "+" + country.dialCode;
    values.phoneNumber = values.countryCode + values.phoneNumber;
  };
  const fetchClientUsers = async () => {
    getClientUsers(headerValues, (data) => {
      setUserTotalRows(data.Result_Output.totalDocs);
      setuserRows(data.Result_Output.docs);
    }, dispatch)

  };
  const fetchSubsciptionTransactions = async () => {
    getSubsciptionTransactions(headerValues, (data) => {
      setSubscriptionTotalRows(data.Result_Output.totalDocs);
      setsubscriptionRows(data.Result_Output.docs)
    }, dispatch)

  };
  const fetchInvoicesAndPayments = async () => {
    getInvoicesAndPayments(headerValues, (data) => {
      setInvoiceTotalRows(data.Result_Output.totalDocs)
      setinvoiceRows(data.Result_Output.docs);
    }, dispatch)
  };


  useEffect(() => {
    function handleTabsOrientation() {
      return window.innerWidth < breakpoints.values.sm
        ? setTabsOrientation("vertical")
        : setTabsOrientation("horizontal");
    }

    window.addEventListener("resize", handleTabsOrientation);
    handleTabsOrientation();
    return () => window.removeEventListener("resize", handleTabsOrientation);
  }, [tabsOrientation]);

  useEffect(() => {
    if (table === "client_info") {
      setshowClientTable(true);
      setShowPlanFeatureTable(false);
      setHrWidth(163);
      setshowUsersTable(false);
      setHrMarginLeft(defaultHrMarginLeft);
      setshowTransaction(false);
      setshowinvoicePayments(false);
    }
    else if (table === "plan_feature") {
      setshowClientTable(false);
      setShowPlanFeatureTable(true);
      setHrWidth(135);
      setshowUsersTable(false);
      setHrMarginLeft(229);
      setshowTransaction(false);
      setshowinvoicePayments(false);
    } else if (table === "client_users") {

      setshowClientTable(false);
      setShowPlanFeatureTable(false);
      setshowUsersTable(true);
      setshowTransaction(false);
      setshowinvoicePayments(false);
    } else if (table === "subscription_Transaction") {

      setshowClientTable(false);
      setShowPlanFeatureTable(false);
      setshowUsersTable(false);
      setshowTransaction(true);
      setshowinvoicePayments(false);

    } else if (table === "invoice_payments") {

      setshowClientTable(false);
      setShowPlanFeatureTable(false);
      setshowUsersTable(false);
      setshowTransaction(false);
      setshowinvoicePayments(true);

    }
  }, [table]);
  const handlePageChange = page => {
    headerValues.page = page;
    setCustomerReload(!customerReload)
  };
  const handlePerRowsChange = async (newPerPage, page) => {
    headerValues.page = page;
    headerValues.limit = newPerPage
    setPerPage(newPerPage);
  };
  const handleSort = async (type, value) => {
    headerValues.sortingType = value;
    headerValues.sortingField = type;
  };
  const handleSearchFilter = (event) => {
    setHeaderValues({ ...headerValues, filterValues: event.target.value });
  };

  const clientInfoTable = (
    <>
      {showClientTable && (
        <MDBox pt={3} mb={-1.5} px={2}>
          <Grid container columnSpacing={5}>
            <Grid item xs={12} lg={4}>
              <MDBox component="form" role="form">
                <MDBox mb={4} xs={12}>
                  <TextField
                    type="text"
                    label=" Business Name"
                    variant="outlined"
                    fullWidth
                    pattern="^[a-zA-Z 0-9]*$"
                    maxLength="30"
                    value={values.companyName}
                    disabled={checkDisabled}
                  />
                </MDBox>
              </MDBox>
            </Grid>
            <Grid item xs={12} lg={4}>
              <MuiPhoneNumber
                defaultCountry={"au"}
                type="text"
                label="Mobile Number"
                variant="outlined"
                fullWidth
                disabled={checkDisabled}
                value={values.phoneNumber}
                onChange={(phone, country) => setPhoneValues(phone, country)}
              />
            </Grid>



            <Grid item xs={12} lg={4}>
              <MDBox component="form" role="form">
                <MDBox mb={4} xs={12}>
                  <TextField
                    type="text"
                    label="Email Address"
                    variant="outlined"
                    fullWidth
                    disabled={checkDisabled}
                    value={values.emailAddress}
                  />
                </MDBox>
              </MDBox>
            </Grid>

            <Grid item xs={12} lg={4}>
              <MDBox component="form" role="form">
                <MDBox mb={4} xs={12}>
                  <TextField
                    type="text"
                    label="Street Address"
                    variant="outlined"
                    InputLabelProps={{ shrink: true }}
                    fullWidth
                    maxLength="200"
                    disabled={checkDisabled}
                    value={values.companyStreetAddress}
                  />
                </MDBox>
              </MDBox>
            </Grid>
            <Grid item xs={12} lg={4}>
              <MDBox component="form" role="form">
                <MDBox mb={4} xs={12}>
                  <TextField
                    type="text"
                    label="City"
                    variant="outlined"
                    fullWidth
                    disabled={checkDisabled}
                    maxLength="100"
                    value={values.companyCity}
                  />
                </MDBox>
              </MDBox>
            </Grid>
            <Grid item xs={12} lg={4}>
              <MDBox component="form" role="form">
                <MDBox mb={4} xs={12}>
                  <TextField
                    type="text"
                    label="Zip Code"
                    variant="outlined"
                    fullWidth
                    pattern="^[0-9]+$"
                    maxLength="4"
                    value={values.companyZipCode}
                    disabled={checkDisabled}
                  />
                </MDBox>
              </MDBox>
            </Grid>
            <Grid item xs={12} lg={4}>
              <MDBox mb={4} xs={12}>
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">Country</InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    style={{ minHeight: "3em" }}
                    label="Country"
                    value={values.companyCountry}
                    disabled={checkDisabled}
                  >
                    {country}
                  </Select>
                </FormControl>
              </MDBox>
            </Grid>
            <Grid item xs={12} lg={4}>
              <MDBox mb={4} xs={12}>
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">State</InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    style={{ minHeight: "3em" }}
                    label="State"
                    disabled={checkDisabled}
                    value={values.companyState}
                  >
                    {state}
                  </Select>
                </FormControl>
              </MDBox>
            </Grid>
          </Grid>
        </MDBox>
      )}
    </>
  );


  const planFeaturCol = [
    {
      name: "Feature Name",
      selector: row => row.featureName,
      sortable: true,
      sortField: 'featureName',
      left: "true",
    },

    {
      name: "Feature Type",
      selector: row => row.featureType,
      sortable: true,
      sortField: 'featureType',
      center: true,
    },

    {
      name: "Feature Count",
      selector: row => row.featureCount,
      sortable: true,
      sortField: 'featureCount',
      center: "true",
    },

  ]


  const planFeaturesTable = (
    <>
      {showPlanFeatureTable && (
        <>
          <Grid container display={"flex"} justifyContent="end" mt={-0.6} pt={2} gap={1} px={2.2}>
            <Grid lg={2.5} xs={6}>
              <TextField
                type="text"
                variant="outlined"
                fullWidth
                className="searchButton"
                placeholder="Search..."
                label="Search Filter"
                value={values.filterValues}
                onChange={handleSearchFilter}
                onKeyUp={(e) => {
                  if (e.key === "Enter") setCustomerReload(!customerReload);
                }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment  >
                      <Button style={{ borderRadius: "0px 0.5rem  0.5rem 0px", boxShadow: "none", background: barColor }} variant="contained" onClick={() => setCustomerReload(!customerReload)}>
                        <GridSearchIcon color="white" />
                      </Button>
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
          </Grid>
          <BTable
            columns={planFeaturCol}
            data={rows}
            selectableRows={false}
            sortingType={handleSort}
            sortServer
            pagination
            paginationServer
            paginationTotalRows={totalRows}
            onChangeRowsPerPage={handlePerRowsChange}
            onChangePage={handlePageChange}
            fixedHeaderScrollHeight="410px"
            fixedHeader={true}

          />

        </>
      )}
    </>
  );

  const userCol = [
    {
      name: "First Name",
      selector: row => row.firstName,
      sortable: true,
      sortField: 'firstName',
      // style: { paddingLeft: "8px" }
    },
    {
      name: "Last Name",
      selector: row => row.lastName,
      sortable: true,
      sortField: 'lastName',
      center: true
    },
    {
      name: "Email Address",
      selector: row => row.emailAddress,
      sortable: true,
      sortField: 'emailAddress',
      center: true
    },


    {
      name: "Role",
      selector: row => row.role,
      sortable: true,
      sortField: 'role',
      center: true
    },
    {
      name: "Status",
      selector: row => row.userStatus,
      sortable: true,
      sortField: 'userStatus',
      center: true
    },


  ]
  const clientUsersTable = (
    <>
      {showUsersTable && (
        <>


          <Grid container display={"flex"} justifyContent="end" pt={2} gap={1} px={2.2}>
            <Grid lg={2.5} xs={6}>
              <TextField
                type="text"
                variant="outlined"
                fullWidth
                className="searchButton"
                placeholder="Search..."
                label="Search Filter"
                value={values.filterValues}
                onChange={handleSearchFilter}
                onKeyUp={(e) => {
                  if (e.key === "Enter") setCustomerReload(!customerReload);
                }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment  >
                      <Button style={{ borderRadius: "0px 0.5rem  0.5rem 0px", boxShadow: "none", background: barColor }} variant="contained" onClick={() => setCustomerReload(!customerReload)}>
                        <GridSearchIcon color="white" />
                      </Button>
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
          </Grid>
          <BTable
            columns={userCol}
            data={userRows}
            selectableRows={false}
            sortingType={handleSort}
            sortServer
            pagination
            paginationServer
            paginationTotalRows={userTotalRows}
            onChangeRowsPerPage={handlePerRowsChange}
            onChangePage={handlePageChange}
            fixedHeaderScrollHeight="410px"
            fixedHeader={true}

          />


        </>
      )}
    </>
  );

  let subscriptionCol = [
    {
      name: "Transaction Date & Time",
      selector: row => row.transactionDateString,
      sortable: true,
      sortField: 'transactionDateTime',
      // style: { paddingLeft: '10px' }
    },
    {
      name: "Transaction Type",
      selector: row => row.transactionType,
      sortable: true,
      sortField: 'transactionType',
      center: true
    },
    {
      name: "Old Plan Name",
      selector: row => row.oldPlanName,
      sortable: true,
      sortField: 'oldPlanName',
      center: true
    },
    {
      name: "New Plan Name",
      selector: row => row.newPlanName,
      sortable: true,
      sortField: 'newPlanName',
      center: true
    },
    {
      name: "Status",
      selector: row => row.status,
      sortable: true,
      sortField: 'status',
      center: true
    },
    {
      name: "Notes",
      selector: row => row.notes,
      sortable: true,
      sortField: 'notes',
      center: true
    },


  ]
  const showSubscriptionTransaction = (
    <>
      {showTransaction && (
        <>

          <Grid container display={"flex"} justifyContent="end" mt={-0.6} pt={2} gap={1} px={2.2}>
            <Grid lg={2.5} xs={6}>
              <TextField
                type="text"
                variant="outlined"
                fullWidth
                className="searchButton"
                placeholder="Search..."
                label="Search Filter"
                value={values.filterValues}
                onChange={handleSearchFilter}
                onKeyUp={(e) => {
                  if (e.key === "Enter") setCustomerReload(!customerReload);
                }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment  >
                      <Button style={{ borderRadius: "0px 0.5rem  0.5rem 0px", boxShadow: "none", background: barColor }} variant="contained" onClick={() => setCustomerReload(!customerReload)}>
                        <GridSearchIcon color="white" />
                      </Button>
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
          </Grid>
          <BTable
            columns={subscriptionCol}
            data={subscriptionRows}
            selectableRows={false}
            sortingType={handleSort}
            sortServer
            pagination
            paginationServer
            paginationTotalRows={subscriptionTotalRows}
            onChangeRowsPerPage={handlePerRowsChange}
            onChangePage={handlePageChange}
            fixedHeaderScrollHeight="410px"
            fixedHeader={true}

          />



        </>
      )}
    </>
  );



  let invoiceCol = [
    {
      name: "Invoice Date Time",
      selector: row => row.invoiceDateString,
      sortable: true,
      sortField: 'invoiceDate',
      style: { paddingLeft: "8px" }
    },
    {
      name: "Invoice Number",
      selector: row => row.invoiceNumber,
      sortable: true,
      sortField: 'invoiceNumber',
      center: true
    },
    {
      name: "Transaction Type",
      selector: row => row.transactionType,
      sortable: true,
      sortField: 'transactionType',
      center: true
    },
    {
      name: "Invoice Amount($)",
      selector: row => row.invoiceAmount,
      sortable: true,
      sortField: 'invoiceAmount',
      center: true
    },
    {
      name: "Invoice Status",
      selector: row => row.invoiceStatus,
      sortable: true,
      sortField: 'invoiceStatus',
      center: true
    },
    {
      name: "Payment Date Time",
      selector: row => row.paymentDateString,
      sortable: true,
      sortField: 'paymentDate',
      center: true
    },
    {
      // name: "Payment Amount($)",
      name: <p style={{ paddingLeft: "36px" }}>Payment Amount($)</p>,
      selector: row => row.paymentAmount,
      sortable: true,
      sortField: 'paymentAmount',
      center: true
    },
  ]
  const showInvoiceAndPayments = (
    <>
      {showinvoicePayments && (
        <>

          <Grid container display={"flex"} justifyContent="end" mt={-0.6} pt={2} gap={1} px={2.2}>
            <Grid lg={2.5} xs={6}>
              <TextField
                type="text"
                variant="outlined"
                fullWidth
                className="searchButton"
                placeholder="Search..."
                label="Search Filter"
                value={values.filterValues}
                onChange={handleSearchFilter}
                onKeyUp={(e) => {
                  if (e.key === "Enter") setCustomerReload(!customerReload);
                }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment  >
                      <Button style={{ borderRadius: "0px 0.5rem  0.5rem 0px", boxShadow: "none", background: barColor }} variant="contained" onClick={() => setCustomerReload(!customerReload)}>
                        <GridSearchIcon color="white" />
                      </Button>
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
          </Grid>
          <BTable
            columns={invoiceCol}
            data={invoiceRows}
            selectableRows={false}
            sortingType={handleSort}
            sortServer
            pagination
            paginationServer
            paginationTotalRows={invoiceTotalRows}
            onChangeRowsPerPage={handlePerRowsChange}
            onChangePage={handlePageChange}
            fixedHeaderScrollHeight="410px"
            fixedHeader={true}

          />


        </>
      )}
    </>
  );

  const renderTable = () => {
    return (
      <>
        {clientInfoTable}
        {/* {planCostTable} */}
        {planFeaturesTable}
        {clientUsersTable}
        {showInvoiceAndPayments}
        {showSubscriptionTransaction}
      </>
    );
  };
  const handleSetTabValue = (event, newValue) => setTabValue(newValue);

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <Height val={30} />
      <Card>
        <PageTitle screenName={screenName} />

        <Grid container mt={2}>
          <Grid item xs={12} md={6} lg={8} px={2} mb={-3.5}>

            <AppBar position="inherit">
              <Tabs
                orientation={tabsOrientation}
                value={tabValue}
                onChange={handleSetTabValue}
                className="tab-container"
                sx={{
                  "& .Mui-selected": { color: "#fff !important", background: `${barColor} !important`, },
                  '.MuiTabs-indicator': { background: `${barColor} !important` },
                }}
              >
                <Tab onClick={() => {
                  clearValues(); setScreenName("Client Information");
                  setTable("client_info")
                }} label="Client Information" />
                <Tab onClick={() => {
                  clearValues(); setScreenName("Plan Features");
                  setTable("plan_feature");
                }} label="Plan Features" />
                <Tab
                  onClick={() => {
                    clearValues(); setScreenName("Subscription Transactions");
                    setTable("subscription_Transaction");
                  }}
                  label="Subscription Transactions"
                />
                <Tab onClick={() => {
                  clearValues(); setScreenName("Invoices And Payments");
                  setTable("invoice_payments")
                }} label="Invoices And Payments" />
                <Tab onClick={() => {
                  clearValues(); setScreenName("Users");
                  setTable("client_users")
                }} label="Users" />
              </Tabs>
            </AppBar>
          </Grid>
          <Grid item xs={12} md={6} lg={4} px={2} sx={{ display: "flex", justifyContent: "right" }}>
            <Grid item xs={12} md={3} lg={4} sx={{ display: "flex", justifyContent: "right" }}>
              <Link to={"/clients"}>
                <MDButton style={{ width: "99px", height: '40px' }} color="warning">
                  Back
                </MDButton>
              </Link>
            </Grid>
          </Grid>
        </Grid>

        {renderTable()}
      </Card>
    </DashboardLayout>
  );
}

export default ClientInfo;
